module.exports = __webpack_public_path__ + "img/sparks-01.86177299.png";